import React from 'react';
import { useGetCompaniesQuery, useGetCompanyByIdQuery } from '../../Companies/Service/companiesApi';
import { mapCompanyToInvoiceLookup, type InvoiceCompanyLookup } from './companiesLookupMapper';

export const useGetInvoiceCompaniesLookupQuery = () => {
  const queryResult = useGetCompaniesQuery();

  const data = React.useMemo(
    () =>
      (queryResult.data ?? [])
        .map((company) => mapCompanyToInvoiceLookup(company))
        .filter((company): company is InvoiceCompanyLookup => Boolean(company)),
    [queryResult.data]
  );

  return {
    ...queryResult,
    data,
  };
};

export const useGetInvoiceCompanyLookupByIdQuery = (
  companyId: number,
  options?: { skip?: boolean }
) => {
  const queryResult = useGetCompanyByIdQuery(companyId, options);

  const data = React.useMemo(() => mapCompanyToInvoiceLookup(queryResult.data), [queryResult.data]);

  return {
    ...queryResult,
    data,
  };
};
